import styled from "styled-components";

import { easingSeconds } from "core/animation";

export const Container = styled.div`
    display: flex;
    align-items: center;

    & > *:not(:last-of-type) {
        ${({ spaceBetweenIcons }) => `margin-right: ${spaceBetweenIcons}`};
    }

    svg {
        transition: opacity ${easingSeconds};

        &:hover {
            opacity: 0.6;
        }
    }
`;
